(function(){
'use strict';
function parentTrigger(a){
  if(!a)return false;
  var t=(a.textContent||'').replace(/▾/g,'').replace(/\s+/g,' ').trim().toUpperCase();
  if(t!=='SHOP'&&t!=='LEARN')return false;
  var li=a.closest&&a.closest('li');
  if(!li)return false;
  var inHeader=!!(a.closest('.header')||a.closest('#header')||a.closest('#nav'));
  var hasSubmenu=!!li.querySelector('ul,.dropdown');
  return inHeader&&hasSubmenu;
}
function prepare(a){
  if(!parentTrigger(a))return;
  a.removeAttribute('href');
  a.setAttribute('role','button');
  a.setAttribute('tabindex','0');
  a.setAttribute('aria-haspopup','true');
}
function fix(){
  document.querySelectorAll('.header a,#header a,#nav a').forEach(prepare);
}
document.addEventListener('click',function(e){
  var a=e.target.closest&&e.target.closest('a');
  if(!parentTrigger(a))return;
  e.preventDefault();
},true);
document.addEventListener('keydown',function(e){
  var a=e.target.closest&&e.target.closest('a');
  if(!parentTrigger(a))return;
  if(e.key==='Enter'||e.key===' '){
    e.preventDefault();
    a.click();
  }
},true);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fix);else fix();
document.addEventListener('shopify:section:load',function(){setTimeout(fix,0);});
})();